// // // components/Products.jsx
// // import React from "react";
// // import { FlaskConical, Cpu, ClipboardList } from "lucide-react";

// // export default function Products() {
// //   return (
// //     <section className="py-20 bg-gray-100" id="products">
// //       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
// //         <div className="text-center mb-16">
// //           <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
// //             Our Products
// //           </h2>
// //           <p className="text-xl text-gray-600 max-w-3xl mx-auto">
// //             Revolutionizing dairy tech with innovative analyzers, IoT solutions,
// //             and seamless software tools.
// //           </p>
// //         </div>

// //         <div className="grid md:grid-cols-3 gap-10">
// //           <div className="bg-white p-8 rounded-2xl shadow hover:shadow-lg transition">
// //             <div className="bg-blue-600 text-white w-14 h-14 rounded-full flex items-center justify-center mb-4 mx-auto">
// //               <FlaskConical className="w-6 h-6" />
// //             </div>
// //             <h3 className="text-xl font-semibold text-center text-gray-900 mb-2">
// //               Ultrasonic Milk Analyzer
// //             </h3>
// //             <p className="text-gray-600 text-center">
// //               Ensure accurate and chemical-free milk testing with industry-grade
// //               ultrasonic technology.
// //             </p>
// //           </div>

// //           <div className="bg-white p-8 rounded-2xl shadow hover:shadow-lg transition">
// //             <div className="bg-green-600 text-white w-14 h-14 rounded-full flex items-center justify-center mb-4 mx-auto">
// //               <Cpu className="w-6 h-6" />
// //             </div>
// //             <h3 className="text-xl font-semibold text-center text-gray-900 mb-2">
// //               Dairy IoT Device
// //             </h3>
// //             <p className="text-gray-600 text-center">
// //               Smart IoT hardware for real-time dairy operations, automation, and
// //               analytics integration.
// //             </p>
// //           </div>

// //           <div className="bg-white p-8 rounded-2xl shadow hover:shadow-lg transition">
// //             <div className="bg-orange-600 text-white w-14 h-14 rounded-full flex items-center justify-center mb-4 mx-auto">
// //               <ClipboardList className="w-6 h-6" />
// //             </div>
// //             <h3 className="text-xl font-semibold text-center text-gray-900 mb-2">
// //               Milk Collection Software
// //             </h3>
// //             <p className="text-gray-600 text-center">
// //               Simplify your collection workflows with intuitive, mobile-ready
// //               software and smart data tracking.
// //             </p>
// //           </div>
// //         </div>
// //       </div>
// //     </section>
// //   );
// // }

// import React from "react";
// import {
//   Award,
//   Users,
//   Settings,
//   Target,
//   BarChart3,
//   Beaker,
// } from "lucide-react"; // Adjust if you use a different icon lib
// import { Tabs, TabsList, TabsTrigger, TabsContent } from "@radix-ui/react-tabs"; // Example tabs lib, replace with yours

// export default function ProductsAndServices() {
//   return (
//     <section id="products" className="py-20 bg-white">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-12">
//           Our Products & Services
//         </h2>

//         <Tabs defaultValue="products">
//           <TabsList className="flex justify-center gap-4 mb-12 border-b border-gray-200">
//             <TabsTrigger
//               value="products"
//               className="py-2 px-6 text-gray-700 data-[state=active]:border-b-2 data-[state=active]:border-purple-600 data-[state=active]:text-purple-600 font-semibold transition"
//             >
//               Products
//             </TabsTrigger>
//             <TabsTrigger
//               value="services"
//               className="py-2 px-6 text-gray-700 data-[state=active]:border-b-2 data-[state=active]:border-purple-600 data-[state=active]:text-purple-600 font-semibold transition"
//             >
//               Services
//             </TabsTrigger>
//           </TabsList>

//           {/* Products Tab */}
//           <TabsContent value="products">
//             <div className="grid md:grid-cols-3 gap-8">
//               <div className="bg-gradient-to-br from-purple-50 to-purple-100 p-8 rounded-2xl text-center hover:shadow-lg transition-shadow">
//                 <div className="bg-purple-500 p-4 rounded-full w-16 h-16 mx-auto mb-6 flex items-center justify-center">
//                   <Award className="w-8 h-8 text-white" />
//                 </div>
//                 <h4 className="text-xl font-bold text-gray-900 mb-4">
//                   Ultrasonic Milk Analyzers
//                 </h4>
//                 <p className="text-gray-600 mb-4">
//                   High-precision devices to measure milk quality parameters
//                   instantly.
//                 </p>
//                 <div className="bg-white p-4 rounded-lg">
//                   <span className="text-sm font-semibold text-purple-600">
//                     Top Seller 2023
//                   </span>
//                 </div>
//               </div>

//               <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-8 rounded-2xl text-center hover:shadow-lg transition-shadow">
//                 <div className="bg-blue-500 p-4 rounded-full w-16 h-16 mx-auto mb-6 flex items-center justify-center">
//                   <Users className="w-8 h-8 text-white" />
//                 </div>
//                 <h4 className="text-xl font-bold text-gray-900 mb-4">
//                   Milk Testing Kits
//                 </h4>
//                 <p className="text-gray-600 mb-4">
//                   Affordable kits designed for on-farm milk quality testing and
//                   analysis.
//                 </p>
//                 <div className="bg-white p-4 rounded-lg">
//                   <span className="text-sm font-semibold text-blue-600">
//                     Trusted by 300+ Farms
//                   </span>
//                 </div>
//               </div>

//               <div className="bg-gradient-to-br from-green-50 to-green-100 p-8 rounded-2xl text-center hover:shadow-lg transition-shadow">
//                 <div className="bg-green-500 p-4 rounded-full w-16 h-16 mx-auto mb-6 flex items-center justify-center">
//                   <Settings className="w-8 h-8 text-white" />
//                 </div>
//                 <h4 className="text-xl font-bold text-gray-900 mb-4">
//                   IoT Dairy Sensors
//                 </h4>
//                 <p className="text-gray-600 mb-4">
//                   Real-time monitoring sensors for automated dairy farm
//                   management systems.
//                 </p>
//                 <div className="bg-white p-4 rounded-lg">
//                   <span className="text-sm font-semibold text-green-600">
//                     Innovative Tech
//                   </span>
//                 </div>
//               </div>
//             </div>
//           </TabsContent>

//           {/* Services Tab */}
//           <TabsContent value="services">
//             <div className="grid md:grid-cols-3 gap-8">
//               <div className="bg-gradient-to-br from-orange-50 to-orange-100 p-8 rounded-2xl text-center hover:shadow-lg transition-shadow">
//                 <div className="bg-orange-500 p-4 rounded-full w-16 h-16 mx-auto mb-6 flex items-center justify-center">
//                   <Target className="w-8 h-8 text-white" />
//                 </div>
//                 <h4 className="text-xl font-bold text-gray-900 mb-4">
//                   Consultation
//                 </h4>
//                 <p className="text-gray-600 mb-4">
//                   Expert advice on improving dairy farm productivity and milk
//                   quality.
//                 </p>
//                 <div className="bg-white p-4 rounded-lg">
//                   <span className="text-sm font-semibold text-orange-600">
//                     Customized Plans
//                   </span>
//                 </div>
//               </div>

//               <div className="bg-gradient-to-br from-cyan-50 to-cyan-100 p-8 rounded-2xl text-center hover:shadow-lg transition-shadow">
//                 <div className="bg-cyan-500 p-4 rounded-full w-16 h-16 mx-auto mb-6 flex items-center justify-center">
//                   <Beaker className="w-8 h-8 text-white" />
//                 </div>
//                 <h4 className="text-xl font-bold text-gray-900 mb-4">
//                   Lab Testing Services
//                 </h4>
//                 <p className="text-gray-600 mb-4">
//                   Professional milk quality testing with detailed reports and
//                   recommendations.
//                 </p>
//                 <div className="bg-white p-4 rounded-lg">
//                   <span className="text-sm font-semibold text-cyan-600">
//                     Accredited Labs
//                   </span>
//                 </div>
//               </div>

//               <div className="bg-gradient-to-br from-purple-50 to-purple-100 p-8 rounded-2xl text-center hover:shadow-lg transition-shadow">
//                 <div className="bg-purple-500 p-4 rounded-full w-16 h-16 mx-auto mb-6 flex items-center justify-center">
//                   <BarChart3 className="w-8 h-8 text-white" />
//                 </div>
//                 <h4 className="text-xl font-bold text-gray-900 mb-4">
//                   Training & Support
//                 </h4>
//                 <p className="text-gray-600 mb-4">
//                   Workshops and ongoing support for farmers and cooperatives to
//                   maximize technology benefits.
//                 </p>
//                 <div className="bg-white p-4 rounded-lg">
//                   <span className="text-sm font-semibold text-purple-600">
//                     Continuous Learning
//                   </span>
//                 </div>
//               </div>
//             </div>
//           </TabsContent>
//         </Tabs>
//       </div>
//     </section>
//   );
// }
// import React from "react";

// export default function Product() {
//   return (
//     <div className="text-center mb-12">
//       <h3 className="text-2xl font-bold text-gray-900 mb-4">Our Products</h3>
//       <p className="text-lg text-gray-600 mb-8">
//         We specialize in ultrasonic milk analyzers designed for accuracy and
//         ease of use.
//       </p>
//       <div className="grid md:grid-cols-3 gap-8">
//         {/* Example product card */}
//         <div className="bg-gradient-to-br from-purple-50 to-purple-100 p-8 rounded-2xl hover:shadow-lg transition-shadow">
//           <h4 className="text-xl font-bold text-gray-900 mb-4">
//             Ultrasonic Milk Analyzer
//           </h4>
//           <p className="text-gray-600 mb-4">
//             High precision analyzer for rapid milk quality testing.
//           </p>
//           <div className="bg-white p-4 rounded-lg">
//             <span className="text-sm font-semibold text-purple-600">
//               Model UM-2024
//             </span>
//           </div>
//         </div>
//         {/* Add more products as needed */}
//       </div>
//     </div>
//   );
// }

import React from "react";
import hexaUltra from "../image/hexaultra.jpg";

import skylink from "../image/skylink.jpg";
import hexamaster from "../image/hexamaster.jpg";

import SkylinkPDF from "../pdf/skylink.pdf";
import HexaMasterPDF from "../pdf/hexa_master_ph_conductivity.pdf";
import HexaUltraPDF from "../pdf/hexa_ultra.pdf";

const products = [
  {
    id: "skylink",
    name: "SKYLINK Milk Analyzer",
    warranty: "1 Year Warranty",
    image: skylink,
    pdf: SkylinkPDF,
    keyFeatures: [
      "Single Ultrasonic Sensor for chemical-free testing",
      "90 samples per hour - high-speed testing",
      "Easy to use & user-friendly interface",
      "Password protected settings",
      "220V AC operable with RS232 connectivity",
      "Compact & portable ABS plastic body",
    ],
    whyChoose: [
      "Ideal for dairy farms and milk cooperatives",
      "High-speed accurate milk quality testing",
      "Secure and efficient milk analysis",
    ],
    specifications: {
      Fat: "0.5 to 12% (±0.10%)",
      SNF: "4 to 12% (±0.15%)",
      Density: "15 to 40% (±1.0%)",
      Protein: "0.15 to 7% (±0.15%)",
      "Added Water": "0 to 99% (±3.0%)",
    },
    styleGradient: "from-blue-50 to-blue-100",
    colorText: "text-blue-900",
    badgeBgColor: "bg-red-500",
  },
  {
    id: "hexaMater",
    name: "Hexa Master Analyzer",
    badgeText: "pH & Conductivity",
    image: hexamaster,
    pdf: HexaMasterPDF,
    advancedFeatures: [
      "Single Ultrasonic Sensors for high precision",
      "pH & Conductivity measurement",
      "Detects pre-mastitis & milk acidity",
      "90 samples per hour capacity",
      "Battery operated (12V DC) for mobile use",
      "Stainless steel body - highly durable",
      "Self-calibration system",
    ],
    specialCapabilities: [
      "IoT compatible for remote monitoring",
      "RS232 & USB connectivity",
      "Cloud storage for real-time tracking",
    ],
    completeSpecifications: {
      Fat: "0.5 to 12% (±0.10%)",
      SNF: "4 to 12% (±0.15%)",
      Protein: "0.15 to 7% (±0.15%)",
      Lactose: "0 to 10% (±0.2%)",
      pH: "0-14 (±0.05)",
      Conductivity: "2-14 ms/cm (±0.1ms/cm)",
      Temperature: "1-42°C (±2.0°C)",
    },
    styleGradient: "from-purple-50 to-purple-100",
    colorText: "text-purple-900",
    badgeBgColor: "bg-yellow-500",
  },
  {
    id: "hexaUltra",
    name: "Hexa Ultra Analyzer",
    warranty: "2 Years Warranty",
    image: hexaUltra,
    pdf: HexaUltraPDF,
    premiumFeatures: [
      "Single Ultrasonic Sensor - chemical-free testing",
      "90 samples per hour high-speed testing",
      "Built-in calibration procedure",
      "Medical grade components",
      "Lightweight ABS plastic portable body",
      "220V AC operable with RS232 connectivity",
      "Password protected security",
    ],
    whyChoose: [
      "Best for collection centers & cooperatives",
      "Low maintenance and easy calibration",
      "Portable & durable design for field use",
      "Secure & reliable testing",
    ],
    technicalSpecifications: {
      Fat: "0.5 to 12% (±0.10%)",
      SNF: "4 to 12% (±0.15%)",
      Density: "15 to 40% (±1.0%)",
      Protein: "0.15 to 7% (±0.15%)",
      "Added Water": "0 to 99% (±3.0%)",
    },
    styleGradient: "from-orange-50 to-orange-100",
    colorText: "text-orange-900",
    badgeBgColor: "bg-red-500",
  },
];

export default function Product({ setSelectedPDF }) {
  return (
    <div className="text-center mb-12">
      <h3 className="text-3xl font-bold text-gray-900 mb-8">Our Products</h3>
      <div className="grid md:grid-cols-3 gap-10 px-4">
        {products.map((product) => (
          <div
            key={product.id}
            className={`p-8 rounded-2xl hover:shadow-lg transition-shadow bg-gradient-to-br ${product.styleGradient}`}
          >
            {/* <img
              src={product.image}
              alt={product.name}
              // className="mx-auto mb-6 max-h-40 object-contain"
              className="mx-auto mb-6 h-40 w-full object-contain rounded-lg shadow-md"
            /> */}
            <div className="relative overflow-hidden rounded-lg h-40 w-full mb-6">
              <img
                src={product.image}
                alt={product.name}
                className="h-full w-full object-cover transform transition-transform duration-300 hover:scale-110"
              />
            </div>
            <h4 className={`text-2xl font-bold mb-2 ${product.colorText}`}>
              {product.name}
            </h4>
            {product.warranty && (
              <div
                className={`inline-block px-3 py-1 mb-4 rounded-full text-white text-sm font-semibold ${product.badgeBgColor}`}
              >
                {product.warranty}
              </div>
            )}
            {product.badgeText && (
              <div
                className={`inline-block px-3 py-1 mb-4 rounded-full text-white text-sm font-semibold ${product.badgeBgColor}`}
              >
                {product.badgeText}
              </div>
            )}
            {/* Features */}
            <div className="mb-4 text-left">
              <h5 className="font-semibold mb-1">Key Features:</h5>
              <ul className="list-disc list-inside text-gray-700">
                {(
                  product.keyFeatures ||
                  product.advancedFeatures ||
                  product.premiumFeatures ||
                  []
                ).map((feature, i) => (
                  <li key={i}>{feature}</li>
                ))}
              </ul>
            </div>
            {/* Why Choose */}
            {(product.whyChoose || product.specialCapabilities) && (
              <div className="mb-4 text-left">
                <h5 className="font-semibold mb-1">Why Choose:</h5>
                <ul className="list-disc list-inside text-gray-700">
                  {(product.whyChoose || product.specialCapabilities).map(
                    (item, i) => (
                      <li key={i}>{item}</li>
                    )
                  )}
                </ul>
              </div>
            )}
            {/* Specifications */}
            <div className="mb-4 text-left">
              <h5 className="font-semibold mb-1">Specifications:</h5>
              <ul className="list-disc list-inside text-gray-700">
                {Object.entries(
                  product.specifications ||
                    product.completeSpecifications ||
                    product.technicalSpecifications ||
                    {}
                ).map(([key, val]) => (
                  <li key={key}>
                    <strong>{key}:</strong> {val}
                  </li>
                ))}
              </ul>
            </div>
            {/*  */}
            {product.pdf && (
              <div className="mt-4">
                <button
                  onClick={() => setSelectedPDF(product.pdf)}
                  className="bg-gray-800 text-white px-4 py-2  rounded-lg text-sm hover:bg-gray-700"
                >
                  View Brochure
                </button>
              </div>
            )}
          </div>
          //
        ))}
      </div>
    </div>
  );
}
